import { assign, DoneInvokeEvent } from "xstate";
import { getObjectKeysAsObject, ParentState } from "@capone/checkout";

import { ActivityMachineContext } from "../../../modules/book/state/types";
import {
  SetSpecialRequirementEvent,
  SetSelectedPickupPointEvent,
  SetHotelSelectionEvent,
  SetHotelNameEvent,
  SetAddressEvent,
  SetCityEvent,
  SetZipCodeEvent,
  SetSelectedLangGuideEvent,
} from "../../../modules/book/state/events";

export const actions = {
  setSelectedPickupPoint: assign(
    (ctx: ActivityMachineContext, event: SetSelectedPickupPointEvent) => {
      ctx[ParentState.activityAdditionalDetails].selectedPickupPoint =
        event.data;
      return ctx;
    }
  ),

  setHotelSelection: assign(
    (ctx: ActivityMachineContext, event: SetHotelSelectionEvent) => {
      ctx[ParentState.activityAdditionalDetails].hotelSelection = event.data;
      return ctx;
    }
  ),

  setHotelName: assign(
    (ctx: ActivityMachineContext, event: SetHotelNameEvent) => {
      ctx[ParentState.activityAdditionalDetails].hotelName = event.data;
      return ctx;
    }
  ),

  setAddress: assign((ctx: ActivityMachineContext, event: SetAddressEvent) => {
    ctx[ParentState.activityAdditionalDetails].address = event.data;
    return ctx;
  }),

  setCity: assign((ctx: ActivityMachineContext, event: SetCityEvent) => {
    ctx[ParentState.activityAdditionalDetails].city = event.data;
    return ctx;
  }),

  setZipCode: assign((ctx: ActivityMachineContext, event: SetZipCodeEvent) => {
    ctx[ParentState.activityAdditionalDetails].zipCode = event.data;
    return ctx;
  }),

  setSelectedLangGuide: assign(
    (ctx: ActivityMachineContext, event: SetSelectedLangGuideEvent) => {
      ctx[ParentState.activityAdditionalDetails].selectedLangGuide = event.data;
      return ctx;
    }
  ),

  setSpecialRequirement: assign(
    (ctx: ActivityMachineContext, event: SetSpecialRequirementEvent) => {
      ctx[ParentState.activityAdditionalDetails].specialRequirement =
        event.data;
      return ctx;
    }
  ),

  setAdditionalDetailsError: assign(
    (ctx: ActivityMachineContext, event: DoneInvokeEvent<any>) => {
      ctx[ParentState.activityAdditionalDetails].errors = event.data;
      return ctx;
    }
  ),

  clearErrors: assign((ctx: ActivityMachineContext) => {
    ctx[ParentState.activityAdditionalDetails].errors = [];
    return ctx;
  }),
};

export const ActionTypes = getObjectKeysAsObject(actions);
